import { useMemo } from "react";
import { usePunditUserContext } from "@circle-react/contexts";

interface DevelopersAccessFlagsType {
  isAdminApiFeatureEnabled: boolean;
  isApiFeatureEnabled: boolean;
  isDataApiFeatureEnabled: boolean;
  isHeadlessApiFeatureEnabled: boolean;
  isOverviewTabEnabled: boolean;
}

const defaultDevelopersAccessFlags: DevelopersAccessFlagsType = {
  isApiFeatureEnabled: false,
  isAdminApiFeatureEnabled: false,
  isDataApiFeatureEnabled: false,
  isHeadlessApiFeatureEnabled: false,
  isOverviewTabEnabled: false,
};

export const useDevelopersAccessFlags = (): DevelopersAccessFlagsType => {
  const { currentCommunity, isLoading } = usePunditUserContext();

  return useMemo(() => {
    if (isLoading || !currentCommunity) {
      return defaultDevelopersAccessFlags;
    }

    const {
      api_access_feature_flag_enabled: isApiFeatureEnabled,
      admin_api_feature_flag_enabled: isAdminApiFeatureEnabled,
      headless_api_feature_flag_enabled: isHeadlessApiFeatureEnabled,
      data_api_feature_flag_enabled: isDataApiFeatureEnabled,
    } = currentCommunity;

    return {
      isApiFeatureEnabled,
      isAdminApiFeatureEnabled,
      isDataApiFeatureEnabled,
      isHeadlessApiFeatureEnabled,
      isOverviewTabEnabled:
        isAdminApiFeatureEnabled || isHeadlessApiFeatureEnabled,
    };
  }, [currentCommunity, isLoading]);
};
